import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
    DndContext,
    closestCenter
} from "@dnd-kit/core";
import {
    SortableContext,
    useSortable,
    arrayMove,
    rectSortingStrategy
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableImage({ id, src, onRemove }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: "grab",
        position: "relative",
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes}>
            {/* Remove button */}

            <div {...listeners}>
                <img
                    src={src}
                    alt=""
                    style={{
                        width: 104,
                        height: 130,
                        objectFit: "contain",
                        borderRadius: 8,
                        display: "block",
                        border: "1px solid #dedede",
                        borderBottom: "none",
                        // padding: 2,
                    }}
                />
            </div>
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove(id);
                }}
                style={{
                    // display: "none",
                    position: "absolute",
                    bottom: 0,
                    background: "rgba(152, 3, 3, 1)",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "1px 1px 8px 8px",
                    width: 104,
                    height: 24,
                    cursor: "pointer",
                    zIndex: 20
                }}
            >
                Remove
            </button>
        </div>
    );
}



export default function ImageDropZone({ showPreview = true, onChange }) {
    const [files, setFiles] = useState([]);

    const onDrop = useCallback((acceptedFiles) => {
        const mappedFiles = acceptedFiles.map((file) => ({
            id: crypto.randomUUID(),
            file,
            preview: URL.createObjectURL(file)
        }));

        setFiles((prev) => [...prev, ...mappedFiles]);
    }, []);

    const { getRootProps, getInputProps, isDragActive } =
        useDropzone({
            onDrop,
            accept: { "image/*": [] }
        });

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        setFiles((items) => {
            const oldIndex = items.findIndex(i => i.id === active.id);
            const newIndex = items.findIndex(i => i.id === over.id);
            return arrayMove(items, oldIndex, newIndex);
        });
    };

    // Cleanup blob URLs
    useEffect(() => {
        return () => files.forEach(f => URL.revokeObjectURL(f.preview));
    }, [files]);

    const removeImage = (id) => {
        setFiles((prev) => {
            const removed = prev.find(f => f.id === id);
            if (removed) URL.revokeObjectURL(removed.preview);
            return prev.filter(f => f.id !== id);
        });
    };

    useEffect(() => {
        onChange?.(files.map(f => f.file)); 
    }, [files, onChange]);

    return (
        <>
            {/* Dropzone */}
            <div
                {...getRootProps()}
                style={{
                    padding: 30,
                    border: "2px dashed #aaa",
                    borderRadius: 10,
                    textAlign: "center",
                    marginBottom: 20
                }}
            >
                <input {...getInputProps()} />
                {isDragActive
                    ? "Drop images here..."
                    : "Drag & drop images or click"}
            </div>

            {/* Preview + Rearrange */}
            <DndContext
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
                style={{ padding: 5}}
            >
                <SortableContext
                    items={files.map(f => f.id)}
                    strategy={rectSortingStrategy}
                >
                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12, }}>
                        {files.map((f) => (
                            <SortableImage
                                key={f.id}
                                id={f.id}
                                src={f.preview}
                                onRemove={removeImage}
                            />
                        ))}
                    </div>
                </SortableContext>
            </DndContext>
        </>
    );
}
